// src/config/routesConfig.ts
import DashboardPage from '../pages/dashboard/DashboardPage'; 
import FinanceDashboardPage from '../pages/finance-dashboard/FinanceDashboardPage';
import MasterDataDashboardPage from '../pages/master-data-dashboard/MasterDataDashboardPage';
import LeadsDashboardPage from '../pages/leads-dashboard/LeadsDashboardPage';
import CommonDashboard from '../pages/CommonDashboard';
import Login from '../pages/Login';
import NotFound from '../pages/NotFound';
import UserList from '../pages/users/UserList';
import UserForm from '../pages/users/UserForm';
import RoleList from '../pages/roles/RoleList';
import RoleForm from '../pages/roles/RoleForm'; 
import ResetPassword from '../pages/ResetPassword';
import { isAuthenticated } from '../utils/auth';
import LoginHistoryPage from '../pages/loginHistories/LoginHistoryPage';
import PasswordHistoryPage from '../pages/passwordHistories/PasswordHistoryPage';
import EditProfile from '../pages/EditProfile';
import PlApps from '../pages/PlApps';
import { faDashboard, faTools, faUser, faUsers, faMoneyBillWave, faFile } from '@fortawesome/free-solid-svg-icons';
import { AppRoute, generateModuleRoutes } from '../utils/generateModuleCrud'; 
import AccountsExcelUpload from '../components/AccountsExcelUpload';
import ExpenseList from '../pages/expenses/ExpenseList';
import ExpenseForm from '../pages/expenses/ExpenseForm';
import ExpenseExcelUpload from '../components/ExpenseExcelUpload';
import DocumentList from '../pages/documents/DocumentList';
import DocumentForm from '../pages/documents/DocumentForm';
import DocumentExcelUpload from '../components/DocumentExcelUpload';



const userRoutes = generateModuleRoutes({
  basePath: 'accounts/users',
  label: 'Users',
  icon: faUser,
  listElement: <UserList />,
  formElement: <UserForm />,
  excelElement: <AccountsExcelUpload />,
  menuOrder: 4,
}); 
const roleRoutes = generateModuleRoutes({
  basePath: 'accounts/roles',
  label: 'Roles',
  icon: faUsers,
  listElement: <RoleList />,
  formElement: <RoleForm />,
  excelElement: <AccountsExcelUpload />,
  menuOrder: 5,
});

const expenseRoutes = generateModuleRoutes({
  basePath: 'finance/expenses',
  label: 'Expenses',
  icon: faMoneyBillWave,
  listElement: <ExpenseList />,
  formElement: <ExpenseForm />,
  excelElement: <ExpenseExcelUpload />,
  menuOrder: 6,
});

const documentRoutes = generateModuleRoutes({
  basePath: 'master-data/documents',
  label: 'Documents',
  icon: faFile,
  listElement: <DocumentList />,
  formElement: <DocumentForm />,
  excelElement: <DocumentExcelUpload />,
  menuOrder: 4,
});


export const appRoutes: AppRoute[] = [
  {
    path: '/',
    title: 'Common Dashboard',
    element: <CommonDashboard />,
    layout: 'none',
  },
  {
    path: '/accounts',
    title: 'Accounts Dashboard',
    label: 'Dashboard',
    icon: faDashboard,
    element: <DashboardPage />,
    layout: 'main',
    menuOrder: 1,
    isMenu: true,
  },
  {
    path: '/finance',
    title: 'Finance Dashboard',
    label: 'Dashboard',
    icon: faDashboard,
    element: <FinanceDashboardPage />,
    layout: 'main',
    menuOrder: 2,
    isMenu: true,
  },
  {
    path: '/master-data',
    title: 'Master Data Dashboard',
    label: 'Dashboard',
    icon: faDashboard,
    element: <MasterDataDashboardPage />,
    layout: 'main',
    menuOrder: 3,
    isMenu: true,
  },
  {
    path: '/leads',
    title: 'Leads Dashboard',
    label: 'Dashboard',
    icon: faDashboard,
    element: <LeadsDashboardPage />,
    layout: 'main',
    menuOrder: 4,
    isMenu: true,
  },
  ...userRoutes,
  ...roleRoutes,
  ...expenseRoutes,
  ...documentRoutes,
  {
    path: '/accounts/users/login-histories/:id',
    title: 'View User',
    element: <LoginHistoryPage />,
    layout: 'main',
  },
  {
    path: '/accounts/users/password-histories/:id',
    title: 'Password Change History',
    element: <PasswordHistoryPage />,
    layout: 'main',
  },
 
  {
    path: '/accounts/pl-applications',
    title: 'PL Applications',
    label: 'PL Applications',
    icon: faTools,
    element: <PlApps />,
    layout: 'main',
    isMenu: true,
    menuOrder: 7,
  },
  {
    path: '/login',
    title: 'Login',
    element: <Login />,
    layout: 'none',
  },
  {
    path: '/reset-password',
    title: 'Reset Password',
    element: <ResetPassword />,
    layout: isAuthenticated() ? 'main' : 'none',
    noSidebar: true,
  },
  {
    path: '/edit-profile',
    title: 'Edit Profile',
    element: <EditProfile />,
    layout: 'main',
    noSidebar: true,
  },
  {
    path: '*',
    title: 'Not Found',
    element: <NotFound />,
    layout: 'none',
  },
];
